import { Columns3, List } from 'lucide-react';
import type { TasksView } from '../../hooks/useTasksView';
import { Tabs, TabsList, TabsTrigger } from '../../ui/tabs';

interface TasksViewSwitcherProps {
  value: TasksView;
  onChange: (view: TasksView) => void;
}

export function TasksViewSwitcher({ value, onChange }: TasksViewSwitcherProps) {
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as TasksView)}>
      <TabsList>
        <TabsTrigger value="list" className="gap-1.5">
          <List className="h-3.5 w-3.5" />
          List
        </TabsTrigger>
        <TabsTrigger value="board" className="gap-1.5">
          <Columns3 className="h-3.5 w-3.5" />
          Board
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
